import { render, staticRenderFns } from "./RecuperoPass.vue?vue&type=template&id=3bf10a0d"
import script from "./RecuperoPass.vue?vue&type=script&lang=js"
export * from "./RecuperoPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports